<script>
  import { Phone, PhoneOff, Video } from 'lucide-svelte';

  export let call;
  export let onAccept = () => {};
  export let onReject = () => {};
</script>

<div class="incoming-backdrop">
  <section class="incoming-card" aria-live="assertive">
    <div class="avatar">{call?.fromName?.charAt(0)?.toUpperCase() || '?'}</div>
    <div class="eyebrow">Cuộc gọi đến</div>
    <h2>{call?.fromName || 'Người gọi'}</h2>
    <p>{call?.callType === 'audio' ? 'Cuộc gọi thoại' : 'Cuộc gọi video'}</p>

    <div class="incoming-actions">
      <button class="call-action reject" aria-label="Từ chối cuộc gọi" onclick={onReject}>
        <PhoneOff size={23} />
        <span>Từ chối</span>
      </button>
      <button class="call-action accept" aria-label="Trả lời cuộc gọi" onclick={onAccept}>
        {#if call?.callType === 'audio'}<Phone size={23} />{:else}<Video size={23} />{/if}
        <span>Trả lời</span>
      </button>
    </div>
  </section>
</div>

<style>
  .incoming-backdrop {
    position: fixed;
    inset: 0;
    z-index: 1000;
    display: grid;
    place-items: center;
    padding: 1rem;
    background: rgba(2, 6, 23, 0.65);
    backdrop-filter: blur(18px);
  }

  .incoming-card {
    width: min(100%, 23rem);
    padding: 2rem 1.5rem 1.4rem;
    border: 1px solid rgba(255, 255, 255, 0.7);
    border-radius: 2rem;
    color: #0f172a;
    text-align: center;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 30px 80px rgba(2, 6, 23, 0.35);
  }

  .avatar {
    display: grid;
    place-items: center;
    width: 5rem;
    height: 5rem;
    margin: 0 auto 1rem;
    border-radius: 1.7rem;
    color: white;
    background: linear-gradient(145deg, #60a5fa, #4f46e5);
    box-shadow: 0 20px 40px rgba(79, 70, 229, 0.28);
    font-size: 2rem;
    font-weight: 700;
  }

  .eyebrow {
    color: #2563eb;
    font-size: 0.7rem;
    font-weight: 700;
    letter-spacing: 0.13em;
    text-transform: uppercase;
  }

  h2 {
    margin-top: 0.35rem;
    font-size: 1.3rem;
    font-weight: 700;
  }

  p {
    margin-top: 0.15rem;
    color: #64748b;
    font-size: 0.82rem;
  }

  .incoming-actions {
    display: flex;
    justify-content: center;
    gap: 2.5rem;
    margin-top: 1.8rem;
  }

  .call-action {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.45rem;
    color: #475569;
    font-size: 0.7rem;
    padding: 0;
    border: 0;
    background: transparent;
    appearance: none;
  }

  .call-action :global(svg) {
    box-sizing: content-box;
    padding: 1rem;
    border-radius: 999px;
    color: white;
  }

  .call-action.reject :global(svg) {
    background: #ef4444;
  }

  .call-action.accept :global(svg) {
    background: #22c55e;
  }
</style>
